import { DateTime } from 'luxon';
import { ISO8601TupleType } from 'types/common.types';

export const formatPayPeriodRangeLabel = (range: ISO8601TupleType, locale: string): string => {
  const start = DateTime.fromISO(range[0]).setLocale(locale);
  const end = DateTime.fromISO(range[1]).setLocale(locale);
  if (start.year !== end.year) {
    return `${start.toFormat('LLL d, yyyy')} – ${end.toFormat('LLL d, yyyy')}`;
  }
  if (start.month !== end.month) {
    return `${start.toFormat('LLL d')} – ${end.toFormat('LLL d, yyyy')}`;
  }
  return `${start.toFormat('LLL d')} – ${end.toFormat('d, yyyy')}`;
};
